import axios from 'axios';

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: { "Content-Type": "application/json" }
});

// Function to set headers dynamically
export const setHeaders = (key, value) => {
  axiosInstance.defaults.headers.common[key] = value;
};

// Function to save the access token
// const saveToken = async (token) => {
//   localStorage.setItem('accesstoken', token);
//   setHeaders('x-access-token', token);
// };

// Function to create and attach the response interceptor  RefreshToken
export const createAxiosResponseInterceptor = async () => {
  const interceptor = axiosInstance.interceptors.response.use(
    response => response,
    async (error) => {
      if (error.response.status !== 444) {
        return Promise.reject(error);
      }
      axiosInstance.interceptors.response.eject(interceptor);
      try {
        const refreshToken = localStorage.getItem('refreshToken')
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/RefreshToken`, {
          refreshToken: refreshToken}).then((res) =>{
          saveToken(res);
          window.location.reload()
        })
      } catch(error2) {
        // No refresh token API, so we simply clear tokens and redirect to login
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('accessToken');
        // localStorage.removeItem('user');
        window.location.href = '/'; // Redirect to login page
        return await Promise.reject(error2);
      } finally {createAxiosResponseInterceptor() } // Re-attach the interceptor by running the method
    }
  )
}

const saveToken = async (res)=>{
  localStorage.setItem('refreshToken', res.data[0].refreshToken)
  localStorage.setItem('accessToken', res.data[0].accessToken);
  setHeaders('x-access-token', localStorage.getItem('accessToken'));
 //  localStorage.setItem('user',JSON.stringify( { ...res.data, isSocialLogin: false }));
 }
 
// Ensure the token is set when the application loads
const token = localStorage.getItem('accessToken');
if (token) {
  setHeaders('x-access-token', token);
}

// Attach the interceptor initially
createAxiosResponseInterceptor();

